(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hiknight-universal-mega-menu"] && !Shopify.designMode) return;
  try {
    
(() => {
  const ROOT = '[data-hiknight-universal-mega]';
  const desktopMQ = window.matchMedia('(min-width: 1024px)');
  const finePointerMQ = window.matchMedia('(hover:hover) and (pointer:fine)');

  const normalize = (value) => String(value || '').replace(/\s+/g, ' ').trim().toLowerCase();

  function visible(el) {
    if (!(el instanceof HTMLElement)) return false;
    const r = el.getBoundingClientRect();
    const s = getComputedStyle(el);
    return r.width > 1 && r.height > 1 && s.visibility !== 'hidden' && s.display !== 'none';
  }

  function findTrigger(root) {
    const label = normalize(root.dataset.triggerLabel);
    if (!label) return null;
    const header = document.querySelector('.header-section header') || document.querySelector('header') || document;
    const candidates = [...header.querySelectorAll('a,button,summary,[role="button"]')]
      .filter((el) => !root.contains(el) && visible(el));
    const exact = candidates.find((el) => normalize(el.textContent) === label);
    if (exact) return exact;
    const near = candidates.find((el) => {
      const text = normalize(el.textContent);
      return text.startsWith(label) || text.endsWith(label);
    });
    if (near) return near;

    return [...document.querySelectorAll('header a,header button,header summary,header [role="button"]')]
      .find((el) => !root.contains(el) && visible(el) && normalize(el.textContent) === label) || null;
  }

  function setup(root) {
    if (!(root instanceof HTMLElement)) return;
    if (root.__hiknightUniversalApi) {
      root.__hiknightUniversalApi.rebindTrigger();
      return;
    }

    root.dataset.hiknightUniversalReady = 'true';

    const shell = root.querySelector('.hiknight-universal-mega__shell');
    const backdrop = root.querySelector('[data-hiknight-mega-backdrop]');
    const tabs = [...root.querySelectorAll('[data-hiknight-mega-tab]')];
    const panels = [...root.querySelectorAll('[data-hiknight-mega-panel]')];
    const openMode = root.dataset.openMode || 'hover';
    const closeDelay = Math.max(80, Number(root.dataset.closeDelay || 180));
    const preventNavigation = root.dataset.preventTriggerNavigation === 'true';
    let trigger = null;
    let closeTimer = 0;

    function activate(index) {
      if (!Number.isFinite(index) || index < 0 || index >= tabs.length) return;
      tabs.forEach((tab, i) => tab.setAttribute('aria-selected', i === index ? 'true' : 'false'));
      panels.forEach((panel, i) => { panel.hidden = i !== index; });
    }

    function setTop() {
      if (!trigger || !document.contains(trigger)) trigger = findTrigger(root);
      if (!trigger) return;
      const rect = trigger.getBoundingClientRect();
      const top = Math.max(0, Math.round(rect.bottom));
      root.style.setProperty('--hiknight-mega-top', `${top}px`);
    }

    function clearClose() {
      if (closeTimer) window.clearTimeout(closeTimer);
      closeTimer = 0;
    }

    function open() {
      if (!desktopMQ.matches) return;
      clearClose();
      if (!trigger || !document.contains(trigger)) rebindTrigger();
      if (!trigger) return;
      setTop();
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      trigger.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('hiknight-universal-mega-open');
    }

    function close() {
      clearClose();
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      if (trigger && document.contains(trigger)) trigger.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('hiknight-universal-mega-open');
    }

    function scheduleClose() {
      clearClose();
      closeTimer = window.setTimeout(() => {
        if (trigger?.matches(':hover') || shell?.matches(':hover')) return;
        close();
      }, closeDelay);
    }

    function onTriggerEnter() {
      if (finePointerMQ.matches) open();
    }

    function onTriggerLeave() {
      scheduleClose();
    }

    function onTriggerFocus() {
      open();
    }

    function onTriggerClick(event) {
      if (!desktopMQ.matches) return;
      if (preventNavigation || openMode === 'click') event.preventDefault();
      if (root.classList.contains('is-open')) close(); else open();
    }

    function unbindTrigger() {
      if (!trigger) return;
      trigger.removeEventListener('pointerenter', onTriggerEnter);
      trigger.removeEventListener('pointerleave', onTriggerLeave);
      trigger.removeEventListener('focus', onTriggerFocus);
      trigger.removeEventListener('click', onTriggerClick);
      if (trigger.dataset.hiknightUniversalTrigger === root.id) {
        delete trigger.dataset.hiknightUniversalTrigger;
      }
    }

    function rebindTrigger() {
      const nextTrigger = findTrigger(root);
      if (nextTrigger === trigger && trigger && document.contains(trigger)) {
        setTop();
        return;
      }

      unbindTrigger();
      trigger = nextTrigger;
      if (!trigger) return;

      trigger.dataset.hiknightUniversalTrigger = root.id;
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.setAttribute('aria-expanded', root.classList.contains('is-open') ? 'true' : 'false');

      if (openMode === 'hover') {
        trigger.addEventListener('pointerenter', onTriggerEnter);
        trigger.addEventListener('pointerleave', onTriggerLeave);
        trigger.addEventListener('focus', onTriggerFocus);
      }
      trigger.addEventListener('click', onTriggerClick);
      setTop();
    }

    tabs.forEach((tab, index) => {
      tab.addEventListener('pointerenter', () => { if (finePointerMQ.matches) activate(index); });
      tab.addEventListener('focus', () => activate(index));
      tab.addEventListener('click', () => activate(index));
    });

    shell?.addEventListener('pointerenter', clearClose);
    shell?.addEventListener('pointerleave', scheduleClose);
    backdrop?.addEventListener('click', close);

    function onDocumentClick(event) {
      if (!root.classList.contains('is-open')) return;
      if (root.contains(event.target) || trigger?.contains(event.target)) return;
      close();
    }

    function onDocumentKeydown(event) {
      if (event.key === 'Escape' && root.classList.contains('is-open')) {
        close();
        trigger?.focus();
      }
    }

    function onWindowResize() {
      if (!desktopMQ.matches) close();
      else if (root.classList.contains('is-open')) setTop();
    }

    function onWindowScroll() {
      if (root.classList.contains('is-open')) setTop();
    }

    function destroy() {
      clearClose();
      unbindTrigger();
      document.removeEventListener('click', onDocumentClick);
      document.removeEventListener('keydown', onDocumentKeydown);
      window.removeEventListener('resize', onWindowResize);
      window.removeEventListener('scroll', onWindowScroll);
      root.classList.remove('is-open');
      root.setAttribute('aria-hidden', 'true');
      delete root.__hiknightUniversalApi;
      delete root.dataset.hiknightUniversalReady;
    }

    document.addEventListener('click', onDocumentClick);
    document.addEventListener('keydown', onDocumentKeydown);
    window.addEventListener('resize', onWindowResize, { passive: true });
    window.addEventListener('scroll', onWindowScroll, { passive: true });

    root.__hiknightUniversalApi = {
      open,
      close,
      activate,
      rebindTrigger,
      destroy
    };

    rebindTrigger();
    window.setTimeout(rebindTrigger, 250);
    window.setTimeout(rebindTrigger, 900);
  }

  function init(scope = document) {
    if (scope?.matches?.(ROOT)) setup(scope);
    scope?.querySelectorAll?.(ROOT).forEach(setup);
  }

  function refreshAllTriggers() {
    document.querySelectorAll(ROOT).forEach((root) => {
      setup(root);
      root.__hiknightUniversalApi?.rebindTrigger();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  } else {
    init(document);
  }

  /* Shopify Theme Editor support:
     - Rebind the menu trigger whenever Header is re-rendered.
     - Keep the mega menu visible while its section/block is selected.
     - Activate the selected category block so visual changes are immediate. */
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
    requestAnimationFrame(refreshAllTriggers);
    window.setTimeout(refreshAllTriggers, 120);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const roots = [];
    if (event.target?.matches?.(ROOT)) roots.push(event.target);
    event.target?.querySelectorAll?.(ROOT).forEach((root) => roots.push(root));
    roots.forEach((root) => root.__hiknightUniversalApi?.destroy());
  });

  document.addEventListener('shopify:section:reorder', () => {
    requestAnimationFrame(refreshAllTriggers);
  });

  document.addEventListener('shopify:section:select', (event) => {
    const root = event.target?.matches?.(ROOT)
      ? event.target
      : event.target?.querySelector?.(ROOT);
    if (!root) return;
    setup(root);
    root.__hiknightUniversalApi?.rebindTrigger();
    root.__hiknightUniversalApi?.open();
  });

  document.addEventListener('shopify:section:deselect', (event) => {
    const root = event.target?.matches?.(ROOT)
      ? event.target
      : event.target?.querySelector?.(ROOT);
    root?.__hiknightUniversalApi?.close();
  });

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const root = block?.closest?.(ROOT) || block?.querySelector?.(ROOT);
    if (!root) return;
    setup(root);
    const tab = block.matches?.('[data-hiknight-mega-tab]')
      ? block
      : block.querySelector?.('[data-hiknight-mega-tab]');
    if (tab) root.__hiknightUniversalApi?.activate(Number(tab.dataset.index));
    root.__hiknightUniversalApi?.rebindTrigger();
    root.__hiknightUniversalApi?.open();
  });

  document.addEventListener('shopify:block:deselect', (event) => {
    const root = event.target?.closest?.(ROOT) || event.target?.querySelector?.(ROOT);
    if (!root) return;
    const selectedSection = root.closest('.shopify-section')?.classList.contains('shopify-section--selected');
    if (!selectedSection) root.__hiknightUniversalApi?.close();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
